import formName from 'constants/formName'
import { actions } from 'data'
import { TwoFactorFormType } from 'data/types'
import { call, put } from 'redux-saga/effects'

import { displayCodesWorker } from './displayCodesStep'

export default function* enableSuccessStep(form: TwoFactorFormType) {
  yield put(actions.form.change(formName.TWO_FACTOR, 'loading', false))

  yield put(actions.auth.setTwoFactorStatus(['TOTP']))

  yield call(displayCodesWorker, form)
}
